import { Component, Input, OnInit } from '@angular/core';
import { BookingService } from '../../../booking.service';
import { BookingDTO } from '../../../api/api';
import { SbModalState } from '../modal-state.service';
import { OverrideOptions, OverrideResult } from '../modal.model';

@Component({
  selector: 'sb-medium-group-override-modal',
  templateUrl: './sb-medium-group-override-modal.component.html',
  styleUrls: ['./sb-medium-group-override-modal.component.scss'],
  standalone: false,
})
export class SbMediumGroupOverrideModalComponent implements OnInit {
  constructor(
    public bookingService: BookingService,
    private state: SbModalState
  ) {}

  options: OverrideOptions<any>;
  bookings: BookingDTO[];
  initial: OverrideResult;
  @Input()
  templateId: string;

  ngOnInit(): void {
    this.options = this.state.options.get(this.templateId) as OverrideOptions<any>;
    this.bookings = this.options.bookings;
    this.initial = this.options.initial;
  }

  ok() {
    this.state.modals.get(this.templateId).close({
      overrideAssigned: this.options.initial.overrideAssigned,
      overrideExcluded: this.options.initial.overrideExcluded,
      overrideDeprecated: this.options.initial.overrideDeprecated,
      excludeNotAssigned: this.options.initial.excludeNotAssigned,
    });
  }
}
